import ToolTip from 'antd/es/tooltip';
import styled from 'styled-components';

import { TToolTipProps } from './ToolTip.type';

const SToolTip = styled(ToolTip)<TToolTipProps>``;
export default SToolTip;
